import React from 'react';
import { useSelector } from 'react-redux';
import { RIGHT_PANELS } from 'constants/feature/panel-constants';
import NoteDetailsOcr from './note-details-ocr';
import RenderPolygonBasedStatementDetails from 'utils/ocr-statement-details-utils';
import { useLocation } from 'react-router-dom';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';
import { ELEMENT_SELECT_MODES } from 'constants/feature/modes-constants';
import {
  toggleInternalReferenceCancelModal,
  toggleFormulaCancelModal,
  openCancelModalAfterModalConfirm,
  storeSelectedNoteId,
  storeSelectedNotePseudoId,
} from 'store/actions/panel-cancel-modal-actions';
import { selectNoteFromContentPanel as onNoteClick } from 'store/actions/notes-panel-actions';
import { useDispatch } from 'react-redux';
import { changeIsNewPropertyFromSelectedNote } from 'store/actions/notes-panel-actions';

const NotesDetailsContainerOCR = ({ notesList, scale, dpi, leftSideView }) => {
  const pathName = useLocation().pathname;
  const dispatch = useDispatch();

  const data = useSelector((state) => state.data);
  const ui = useSelector((state) => state.ui);

  const {
    statementSummary: {
      statementSummaryElementsDisplay: { displayElementDetailsOnStatementPage },
    },
    notesPanel: { selectedNote },
    annotationDisplayOptions: annotationDisplayFilter,
  } = data;

  const {
    statementPage: {
      modes: { selectMode },
      panels: { right },
    },
    sideBySideView: { sideBySideElementMap }
  } = ui;

  const handleNoteClick = (
    event,
    selectMode,
    note,
    pseudoElementId,
    onNoteClick,
  ) => {
    if (pathName.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE)) {
      return () => {};
    } else {
      return onClick(event, selectMode, note, pseudoElementId, onNoteClick);
    }
  };

  const onClick = (event, selectMode, note, pseudoElementId, onNoteClick) => {
    if (selectMode === ELEMENT_SELECT_MODES.FORMULA.title) {
      dispatch(toggleFormulaCancelModal(true));
      dispatch(
        storeSelectedNoteId(note.elementId === null ? -1 : note.elementId),
      );
      dispatch(storeSelectedNotePseudoId(pseudoElementId));
      dispatch(openCancelModalAfterModalConfirm(true));
    } else if (selectMode === ELEMENT_SELECT_MODES.INTERNAL_REFERENCE.title) {
      dispatch(toggleInternalReferenceCancelModal(true));
      dispatch(openCancelModalAfterModalConfirm(true));
      dispatch(
        storeSelectedNoteId(note.elementId === null ? -1 : note.elementId),
      );
      dispatch(storeSelectedNotePseudoId(pseudoElementId));
    } else {
      if (event) {
        event.stopPropagation();
      }
      dispatch(
        onNoteClick({
          elementId: note.elementId === null ? -1 : note.elementId,
          pseudoElementId,
        }),
      );
    }
  };

  const pageNotes = [];

  !!notesList.length &&
    notesList.forEach((note) => {
      if (note.ghost) return;

      const {
        ocrSelector: { polygon },
        noteId,
        pseudoElementId,
      } = note;

      const loopCount = polygon.length - 1;
      const isNoteSelected = selectedNote.noteId === noteId;
      const isNoteNew = selectedNote.data.isNew;
      const panelSelected = selectedNote.data.color;
      const isNotesPanelOpen = right === RIGHT_PANELS.NOTES;
      const isSideBySideView = pathName.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE);
      const shouldNotesDisabled = isSideBySideView ? isSideBySideView : leftSideView;

      if (
        displayElementDetailsOnStatementPage &&
        annotationDisplayFilter.note
      ) {
        pageNotes.push(
          <RenderPolygonBasedStatementDetails
            coordinates={polygon}
            scale={scale * dpi}
            key={noteId}
            loopCount={loopCount}
            displayIcon={true}
          >
            <NoteDetailsOcr
              note={note}
              isNoteSelected={isNoteSelected}
              handleNoteClick={handleNoteClick}
              onNoteClick={onNoteClick}
              selectMode={selectMode.title}
              pseudoElementId={pseudoElementId}
              isNoteNew={isNoteNew}
              panelSelected={panelSelected}
              isNotesPanelOpen={isNotesPanelOpen}
              changeIsNewPropertyFromSelectedNote={() =>
                dispatch(changeIsNewPropertyFromSelectedNote(false))
              }
              isCursorAlias={leftSideView}
              shouldNotesDisabled={shouldNotesDisabled}
              leftSideView={leftSideView}
              sideBySideElementMap={sideBySideElementMap}
            />
          </RenderPolygonBasedStatementDetails>,
        );
      }
    });

  return <>{pageNotes}</>;
};

export default NotesDetailsContainerOCR;
